<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/piedmont')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/bruno-giacosa')">Bruno Giacosa
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/cantina-roberto-voerzio')">Cantina Roberto
                        Voerzio
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/conterno-fantino')">Conterno Fantino
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/g-d-vajra')">G. D. Vajra
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/italy/piedmont/gaja')">Gaja
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/giacomo-conterno')">Giacomo Conterno
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/giuseppe-mascarello-e-figlio')">Giuseppe
                        Mascarello e Figlio
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/massolino')">Massolino
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/poderi-aldo-conterno')">Poderi Aldo Conterno
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/roagna')">Roagna
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/tenuta-la-giustiniana')">Tenuta La
                        Giustiniana
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/vigne-marina-coppi')">Vigne Marina Coppi
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/piedmont')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Gaja</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Gli italiani hanno molte parole per buono: eccezionale, grande, magnifico, superbo sono tutti esempi
                        che mi vengono in mente. Ma a volte i superlativi non sono necessari. Quando qualcosa è così eloquente
                        come Gaja, hai semplicemente lasciato che il vino parlasse da solo. Producendo prevalentemente Nebbioli rossi (app
                        L'8% della produzione di 1.000.000 di bottiglie è bianco) con totale dedizione alla qualità senza compromessi,
                        Gaja è un punto di riferimento per tutti i vini piemontesi.
                    </div>

                    <div class="howto-title2">Lady Gaja</div>
                    <div class="howto-text">
                        Una storia di 160 anni governa il marchio Gaja. Fondata su soli 2 ettari di terreno di Barbaresco da
                        Giovanni Gaja, la vigna è ormai alla quinta generazione. Gaia Gaja è al timone e continua
                        la visione di suo padre Angelo di come dovrebbe essere il vino Gaja. Ampiamente accreditato per aver creato Gaja what
                        è oggi, è stata un'idea di Angelo quella di creare Barbaresco monovigna come il Sorì San Lorenzo
                        nel 1967, Sorì Tildìn nel 1970 e Costa Russi nel 1978 (che poi ritirò dal mercato nel
                        1999). Fu anche Angelo ad introdurre grandi cambiamenti nel vigneto di famiglia, in gran parte importato
                        dal suo tempo trascorso in viaggio in Francia. Sfortunatamente, questi non sono stati sempre ben accolti.
                        Si diceva che il padre di Angelo (e nonno di Gaia) Giovanni fosse reticente al cambiamento; di Gaia
                        Rosso a base di Cabernet Sauvignon, Darmagi, significa "che vergogna" nel dialetto piemontese locale, chiamato
                        pare dopo la reazione di Giovanni all'arrivo delle varietà bordolesi nel Barbaresco (forse
                        A Giovanni potrebbe piacere sapere che il vino oggi si vende tra i 150-200 euro a bottiglia).
                        Per fortuna i rapporti tra padre e figlia sono migliori, e insieme hanno portato il
                        nome Gaja saldamente nel 21 ° secolo.
                    </div>

                    <div class="howto-title2">Il vino più costoso d'Italia</div>
                    <div class="howto-text">
                        Gaja è uno dei pochi vini italiani che può competere con Bordeaux o Borgogna in termini di prezzo ea € 450
                        per una bottiglia di Sori St Lorenzo 2016, sono sicuramente ambiziosi. Arrivando in un sano 10 ° su
                        Liv-ex lista dei vigneti più costosi d'Italia, Gaja ha anche tre bottiglie nella Top 50.
                        Questo pone Gaja ben al di sopra della media del vino delle Langhe, che nel 2019 aveva mostrato quasi zero
                        crescita nei 12 mesi precedenti. Gaja, tuttavia, ha fatto pendere la bilancia con una crescita del 35% durante il 2018 e
                        sembra destinato a continuare a salire.
                    </div>

                    <div class="howto-title2">Fatti e annate notevoli</div>
                    <div class="howto-text">
                        <ul>
                            <li>A partire dall'uscita del 2013, Gaja è tornata nel club DOCG che aveva lasciato nel 1996, ora
                                producendo tre vini da singolo vigneto utilizzando la denominazione Barbaresco DOP
                                (La Denominazione di Origine Protetta è l'equivalente di DOCG secondo le regole dell'UE).
                            </li>
                            <li>Sperss, uno dei Barolo di livello più alto di Gaja, sta riscuotendo un crescente interesse e in generale
                                il prezzo aumenta dal 2017. Gli investitori saranno fortunati ad acquistare l'annata 2015 che è
                                "...incredibilmente accessibile per uno Sperss". Prima del rilascio, questa annata ha già
                                prezzi superiori ai 230 euro a bottiglia, anche grazie alla brillante recensione di Antonio Galloni
                                che comprendono 97 punti.
                            </li>
                            <li>L'Institute of Masters of Wine and The Drinks Business' Winemakers' Winemaker Award è
                                giudicato da una giuria di Wine Masters che sono anche vignaioli, insieme a tutti
                                vincitori precedenti da quando il premio è stato istituito per la prima volta nel 2011. Nel marzo 2019, Angelo Gaja è entrato ufficialmente a far parte dei ranghi dei migliori produttori di vino (che includono i vincitori passati Peter Sisseck, Peter Gago, Paul Draper, Anne-Claude Leflaive, Egon Müeller, Alvaro Palacios, Eben Sadie e Jean-Claude Berrouet) per i suoi “eccezionali risultati nel campo della vinificazione”.
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Gaja</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Die Italiener haben viele Wörter für das Gute: eccezionale, grande, magnifico, superbo sind Beispiele dafür
                        Das kommt mir in den Sinn. Aber manchmal sind Superlative nicht nötig. Wenn etwas so beredt ist
                        Als Gaja lässt man den Wein einfach für sich sprechen. Produktion überwiegend roter Nebbiolos (gerade).
                        8 % der 1.000.000-Flaschen-Produktion sind weiß) mit völliger Hingabe an kompromisslose Qualität,
                        Gaja ist ein Maßstab für alle piemontesischen Weine.
                    </div>

                    <div class="howto-title2">Lady Gaja</div>
                    <div class="howto-text">
                        Eine 160-jährige Geschichte prägt die Marke Gaja. Gegründet auf nur 2 Hektar Barbaresco-Boden von
                        Giovanni Gaja führt das Weingut mittlerweile in der fünften Generation. Gaia Gaja ist an der Spitze und macht weiter
                        die Vision ihres Vaters Angelo, wie Gaja-Wein schmecken sollte. Weitgehend als Gajas Werk angesehen
                        Heute war es Angelos Idee, Barbarescos aus einzelnen Lagen wie Sorì San Lorenzo zu kreieren
                        im Jahr 1967, Sorì Tildìn im Jahr 1970 und Costa Russi im Jahr 1978 (die er dann vom Markt nahm).
                        1999). Es war auch Angelo, der große Veränderungen im Weinberg der Familie vornahm, die größtenteils importiert wurden
                        aus seiner Reisezeit in Frankreich. Leider wurden diese nicht immer gut angenommen.
                        Angelos Vater (und Gaias Großvater) Giovanni soll gegenüber Veränderungen zurückhaltend gewesen sein; Gajas
                        Der auf Cabernet Sauvignon basierende Rotwein Darmagi bedeutet im lokalen piemontesischen Dialekt „was für eine Schande“.
                        offenbar nach Giovannis Reaktion auf die Ankunft der Bordeaux-Sorten in Barbaresco (vielleicht
                        Giovanni würde vielleicht gerne wissen, dass der Wein heute zwischen 150 und 200 Euro pro Flasche verkauft wird.
                        Zum Glück sind die Beziehungen zwischen Vater und Tochter besser, und gemeinsam haben sie das geschafft
                        Der Name Gaja ist fest im 21. Jahrhundert verankert.
                    </div>

                    <div class="howto-title2">Italiens teuerster Wein</div>
                    <div class="howto-text">
                        Gaja ist einer der wenigen italienischen Weine, die preislich und für 450 Euro mit Bordeaux oder Burgund mithalten können
                        Für eine Flasche Sori St. Lorenzo 2016 sind sie sicherlich ehrgeizig. Kommt auf einen gesunden 10. Platz
                        Live-Ex-Liste der teuersten Weinberge Italiens, Gaja hat auch drei Flaschen in der Top 50-Liste.
                        Damit liegt Gaja deutlich über dem Durchschnitt für Weine aus der Langhe, die 2019 nahezu keine Ergebnisse erzielt hatten
                        Wachstum in den letzten 12 Monaten. Gaja gab jedoch mit einem Wachstum von 35 % im Jahr 2018 den Ausschlag
                        Es sieht so aus, als würde es weiter steigen.
                    </div>

                    <div class="howto-title2">Bemerkenswerte Fakten und Jahrgänge</div>
                    <div class="howto-text">
                        <ul>
                            <li>Seit der Veröffentlichung im Jahr 2013 ist Gaja nun in den DOCG-Club zurückgekehrt, den er 1996 verlassen hat
                                Herstellung von drei Einzelweinen mit der Appellation Barbaresco DOP
                                (Denominazione di Origine Protetta ist nach EU-Vorschriften das Äquivalent zu DOCG).
                            </li>
                            <li>Sperss, einer der besten Barolos von Gaja, erfreut sich insgesamt zunehmenden Interesses
                                Preissteigerungen seit 2017. Anleger werden das Glück haben, den Jahrgang 2015 zu erwerben
                                „...erschreckend zugänglich für einen Spers.“ Dieser Jahrgang steht bereits vor der Veröffentlichung
                                Der Preis lag bei über 230 € pro Flasche, was zum Teil auf die begeisterte Bewertung von Antonio Galloni zurückzuführen ist
                                die 97 Punkte umfassen.
                            </li>
                            <li>Der Winemakers‘ Winemaker Award des Institute of Masters of Wine und The Drinks Business ist
                                Bewertet von einer Jury aus Weinmeistern, die neben allen auch Winzer sind
                                Bisherige Gewinner seit der ersten Einführung des Preises im Jahr 2011. Im März 2019 wurde Angelo Gaja offiziell in die Riege der Top-Winzer aufgenommen (zu denen die früheren Gewinner Peter Sisseck, Peter Gago, Paul Draper, Anne-Claude Leflaive, Egon Müeller, Alvaro Palacios und Eben gehören Sadie und Jean-Claude Berrouet) für seine „herausragenden Leistungen auf dem Gebiet der Weinherstellung“.
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Gaja</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Les Italiens ont beaucoup de mots pour dire le bien : eccezionale, grande, magnifico, superbo en sont tous des exemples.
                        qui viennent à l'esprit. Mais parfois, les superlatifs ne sont pas nécessaires. Quand quelque chose est aussi éloquent
                        en tant que Gaja, vous laissez simplement le vin parler de lui-même. Produisant des Nebbiolos à dominante rouge (juste
                        8% de la production de 1 000 000 de bouteilles est blanche) avec un dévouement total à une qualité sans compromis,
                        Gaja est une référence pour tous les vins piémontais.
                    </div>

                    <div class="howto-title2">Dame Gaja</div>
                    <div class="howto-text">
                        Une histoire de 160 ans régit la marque Gaja. Fondée sur seulement 2 hectares de terre de Barbaresco par
                        Giovanni Gaja, le vignoble en est maintenant à sa cinquième génération. Gaia Gaja est à la barre, poursuivant
                        la vision de son père Angelo sur le goût du vin Gaja. Largement reconnu pour avoir fait de Gaja ce
                        c'est aujourd'hui, c'était l'idée d'Angelo de créer des Barbarescos à vignoble unique comme Sorì San Lorenzo
                        en 1967, Sorì Tildìn en 1970 et Costa Russi en 1978 (qu'il a ensuite retiré du marché en
                        1999). C'est aussi Angelo qui a introduit d'énormes changements dans le vignoble familial, en grande partie importé
                        de son temps passé à voyager en France. Malheureusement, ceux-ci n'ont pas toujours été bien accueillis.
                        Le père d'Angelo (et le grand-père de Gaia) Giovanni aurait été réticent au changement; Gaja's
                        Le rouge à base de cabernet sauvignon, Darmagi, signifie "quel dommage" dans le dialecte local du Piémont, nommé
                        apparemment après la réaction de Giovanni à l'arrivée des cépages bordelais à Barbaresco (peut-être
                        Giovanni aimerait peut-être savoir que le vin se vend aujourd'hui entre 150 et 200 € la bouteille).
                        Heureusement, les relations entre le père et la fille sont meilleures, et ensemble, ils ont apporté la
                        Nom Gaja fermement dans le 21e siècle.
                    </div>

                    <div class="howto-title2">Le vin le plus cher d'Italie</div>
                    <div class="howto-text">
                        Gaja est l'un des seuls vins italiens pouvant rivaliser avec Bordeaux ou Bourgogne en termes de prix et à 450 €
                        pour une bouteille de Sori St Lorenzo 2016, ils sont assurément ambitieux. Arrivant dans un 10e en bonne santé
                        Liste Liv-ex des vignobles les plus chers d'Italie, Gaja compte également trois bouteilles dans la liste des 50 meilleures.
                        Cela place Gaja bien au-dessus de la moyenne pour le vin des Langhe, qui en 2019 avait montré presque aucun
                        croissance au cours des 12 derniers mois. Gaja, cependant, a fait pencher la balance avec une croissance de 35 % en 2018 et
                        semble prêt à continuer à grimper.
                    </div>

                    <div class="howto-title2">Faits marquants et millésimes</div>
                    <div class="howto-text">
                        <ul>
                            <li>Depuis la sortie de 2013, Gaja est revenu dans le club DOCG qu'il avait quitté en 1996, maintenant
                                produisant trois vins de vignoble unique en utilisant l'appellation Barbaresco DOP
                                (Denominazione di Origine Protetta est l'équivalent de DOCG selon les règles de l'UE).
                            </li>
                            <li>Sperss, l'un des meilleurs barolos de Gaja, suscite un intérêt accru et, dans l'ensemble,
                                hausse des prix depuis 2017. Les investisseurs auront la chance d'acquérir le millésime 2015 qui est
                                "... étonnamment accessible pour un Sperss". Avant sa sortie, ce millésime a déjà
                                prix supérieur à 230 € par bouteille, en partie grâce à la critique élogieuse d'Antonio Galloni
                                qui comprend 97 points.
                            </li>
                            <li>Le prix Winemakers' Winemaker de l'Institute of Masters of Wine and The Drinks Business est
                                jugés par un jury de Wine Masters qui se trouvent également être vignerons, ainsi que tous
                                précédents lauréats depuis la création du prix en 2011. En mars 2019, Angelo Gaja a officiellement rejoint les rangs des meilleurs vignerons (qui comprennent les anciens lauréats Peter Sisseck, Peter Gago, Paul Draper, Anne-Claude Leflaive, Egon Müeller, Alvaro Palacios, Eben Sadie, et Jean-Claude Berrouet) pour sa « réalisation exceptionnelle dans le domaine de la vinification ».
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Gaja</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        The Italians have many words for good: eccezionale, grande, magnifico, superbo are all examples
                        that spring to mind. But sometimes superlatives are not necessary. When something is as eloquent
                        as Gaja, you simply let the wine speak for itself. Producing predominantly red Nebbiolos (just
                        8% of the 1,000,000 bottle production is white) with total dedication to uncompromising quality,
                        Gaja is a benchmark for all Piedmontese wines.
                    </div>

                    <div class="howto-title2">Lady Gaja</div>
                    <div class="howto-text">
                        A 160-year history governs the Gaja brand. Founded on just 2-hectares of Barbaresco soil by
                        Giovanni Gaja, the vineyard is now in its fifth generation. Gaia Gaja is at the helm, continuing
                        her father Angelo’s vision of how Gaja wine should taste. Largely credited as making Gaja what
                        it is today, it was Angelo’s idea to create single vineyard Barbarescos such as Sorì San Lorenzo
                        in 1967, Sorì Tildìn in 1970 and Costa Russi in 1978 (which he then pulled from the market in
                        1999). It was also Angelo who introduced huge changes in the family vineyard, largely imported
                        from his time spent travelling in France. Unfortunately, these were not always well received.
                        Angelo’s father (and Gaia’s grandfather) Giovanni was said to be reticent to change; Gaja's
                        Cabernet Sauvignon-based red, Darmagi, means "what a shame" in the local Piedmont dialect, named
                        apparently after Giovanni’s reaction to the arrival of Bordeaux varieties in Barbaresco (perhaps
                        Giovanni might like to know that the wine is today selling at between €150-200 a bottle).
                        Thankfully relations between father and daughter are better, and together they have brought the
                        Gaja name firmly into the 21st-century.
                    </div>

                    <div class="howto-title2">Italy’s most expensive wine</div>
                    <div class="howto-text">
                        Gaja is one of the only Italian wines that can rival Bordeaux or Burgundy price-wise and at €450
                        for a bottle of 2016 Sori St Lorenzo, they are certainly ambitious. Coming in a healthy 10th on
                        Liv-ex list of Italy’s most expensive vineyards, Gaja also has three bottles in the Top 50 list.
                        This puts Gaja well above average for wine from Langhe, which in 2019 had shown next-to-no
                        growth in the previous 12 months. Gaja, however, tipped the scales at 35% growth during 2018 and
                        looks set to continue climbing.
                    </div>

                    <div class="howto-title2">Notable facts and vintages</div>
                    <div class="howto-text">
                        <ul>
                            <li>Starting with the 2013 release, Gaja has returned to the DOCG club it left in 1996, now
                                producing three single vineyard wines using the Barbaresco DOP appellation
                                (Denominazione di Origine Protetta is the equivalent to DOCG under EU rules).
                            </li>
                            <li>Sperss, one of Gaja’s top-tiered Barolos is enjoying increased interest and overall
                                price rises since 2017. Investors will be fortunate to acquire the 2015 vintage which is
                                “...shockingly approachable for a Sperss”. Prior to release, this vintage has already
                                commanded prices over €230 per bottle in part due to Antonio Galloni’s glowing review
                                which include 97 points.
                            </li>
                            <li>The Institute of Masters of Wine and The Drinks Business’ Winemakers’ Winemaker Award is
                                judged by a panel of Wine Masters who also happen to be winemakers, along with all
                                previous winners since the award was first established in 2011. In March 2019, Angelo Gaja officially joined the ranks of top winemakers (which include past winners Peter Sisseck, Peter Gago, Paul Draper, Anne-Claude Leflaive, Egon Müeller, Alvaro Palacios, Eben Sadie, and Jean-Claude Berrouet) for his “outstanding achievement in the field of winemaking”.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Gaja",
    head: {
        title: 'Gaja | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the world-renowned wines of Gaja, a top Piedmont wine producer known for their exceptional Nebbiolo and Chardonnay varietals. Experience the rich flavor and unparalleled quality of Gaja wines today.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Gaja', src: '/wine-guide/italy/piedmont/gaja'},
            items: [
                {report: 'Bruno Giacosa', src: '/wine-guide/italy/piedmont/bruno-giacosa'},
                {report: 'Cantina Roberto Voerzio', src: '/wine-guide/italy/piedmont/cantina-roberto-voerzio'},
                {report: 'Conterno Fantino', src: '/wine-guide/italy/piedmont/conterno-fantino'},
                {report: 'G. D. Vajra', src: '/wine-guide/italy/piedmont/g-d-vajra'},
                {report: 'Gaja', src: '/wine-guide/italy/piedmont/gaja'},
                {report: 'Giacomo Conterno', src: '/wine-guide/italy/piedmont/giacomo-conterno'},
                {
                    report: 'Giuseppe Mascarello e Figlio',
                    src: '/wine-guide/italy/piedmont/giuseppe-mascarello-e-figlio'
                },
                {report: 'Massolino', src: '/wine-guide/italy/piedmont/massolino'},
                {report: 'Poderi Aldo Conterno', src: '/wine-guide/italy/piedmont/poderi-aldo-conterno'},
                {report: 'Roagna', src: '/wine-guide/italy/piedmont/roagna'},
                {report: 'Tenuta La Giustiniana', src: '/wine-guide/italy/piedmont/tenuta-la-giustiniana'},
                {report: 'Vigne Marina Coppi', src: '/wine-guide/italy/piedmont/vigne-marina-coppi'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
